module.exports = __webpack_public_path__ + "img/error-icon.46ddc054.png";